import Navbar from "../src/component/Navbar";
import Hero from "../src/component/Hero";
import About from "../src/component/About";
import Products from "../src/component/Products";
import Contact from "../src/component/Contact";
import Footer from "../src/component/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BikeDetails from "../src/component/BikeDetails";
import Highlights from "./component/Highlights";

function App() {
  return (
    <div className="font-sans text-gray-800">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <Hero />
                <Highlights/>
                <About />
                <Products />
                <Contact />
              </>
            }
          />
          <Route path="bikeDetails/:id" element={<BikeDetails />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
  
}

export default App;
